import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { PortalUser, PortalUserFormBuilder } from 'src/app/feature-module/portal-users/models/PortalUser';
import { PortalUserService } from 'src/app/feature-module/portal-users/services/portalUser.service';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent extends DialogContentBase implements OnInit {
  constructor(public dialog: DialogRef, private fb: UntypedFormBuilder,
    private userService: PortalUserService,
    private formUtilsService: FormUtilsService, private uiNotification: UiNotificationService) {
    super(dialog);
  }

  addDataForm: UntypedFormGroup;
  addData: PortalUser;
  error: string;

  ngOnInit(): void {
    this.addData = PortalUserFormBuilder.initPortalUser();
    this.addDataForm = PortalUserFormBuilder.getForm(this.fb, this.addData);
  }

  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if(!this.formUtilsService.markFormGroupTouched(this.addDataForm)){
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.addData, this.addDataForm.value);

      this.userService.registerUserProfile(this.addData).subscribe(
        () => { 
          this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
          this.dialog.close({ text: 'OK' }); 
        } );
    
    
  }

}
